import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=64a7c7b8&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=ts&"
export * from "./Terms.vue?vue&type=script&lang=ts&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=64a7c7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a7c7b8",
  null
  
)

export default component.exports